import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WidgetCard from "../widget/card";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { Button } from "@ts-digital/vrc";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config.js";

const WidgetCheckupImpresa = props => {

  const main = useSelector(state => state.main);

  return (
    <div className={"cardSkeletonCheckupImpresa noBoxShadow"}>
      <WidgetCard type="cardSkeletonCheckupImpresa CheckupBanner"
        titleWidget="">
        <div style={{display: "flex", justifyContent: "center", width:"100%", marginTop: "7px"}}>
          <div style={{marginRight: "10px", fontSize:"30px", fontWeight:"300"}}><FontAwesomeIcon icon={["fal", "chart-bar"]}/></div>
          <div style={{fontSize:"24px", alignSelf: "center"}}>Check-up impresa</div>
        </div>
        <div style={{fontSize:"12px", margin: "7px 60px 10px 60px"}}>{<FormattedMessage id="customersWidget.checkupImpresaBanner" />}</div>
        <a href={ TSDIGITAL_PORTALE_PUBLIC_URL +
                    "#/" +
                    main.accountantIdSelected +
                    "/apps/creditrisk/details"
        }
        id="goToTSDigital"
        target="_blank"
        rel="noopener noreferrer">
          <Button className={"checkupImpresaButtonBanner"} colorScheme={"ghost"} style={{color:"white", borderColor:"white"}} kind='secondary'>Scopri di più</Button></a>
      </WidgetCard>
    </div>
  );

};

export default WidgetCheckupImpresa;
